import {Line} from './Line';

declare const THREE: any;

export class Floor extends (THREE.Mesh as { new(geometry, material): any; }) {

  constructor(points: Array<any>) {
    const shape = new THREE.Shape();

    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      if (i === 0) {
        shape.moveTo(point.x, point.y);
      } else {
        shape.lineTo(point.x, point.y);
      }
    }

    shape.lineTo(points[0].x, points[0].y);

    const material = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      side: THREE.DoubleSide
    });

    const geometry = new THREE.ShapeGeometry(shape);
    
    super(geometry, material);
    
    this.rotation.x = Math.PI / 2;
    // for (let i = 0; i < points.length; i++) {
    //   const firstPoint = points[i];
    //   const secondPoint = points[(i + 1) % points.length];
    //   this.add(new Line(
    //     new THREE.Vector3(firstPoint.x, 1, firstPoint.y),
    //     new THREE.Vector3(secondPoint.x, 1, secondPoint.y).rotation.x = )
    //   );
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Floor/index.ts